var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { SAIcons } from '../icon';
import { SAInputContainer } from '../input/input.component';
var StyledInputContainer = styled(SAInputContainer)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  select {\n    appearance: none;\n  }\n"], ["\n  select {\n    appearance: none;\n  }\n"])));
export var SASelect = React.forwardRef(function (_a, ref) {
    var options = _a.options, defaultValue = _a.defaultValue, id = _a.id, label = _a.label, hint = _a.hint, className = _a.className, error = _a.error, fullWidth = _a.fullWidth, additionalProps = __rest(_a, ["options", "defaultValue", "id", "label", "hint", "className", "error", "fullWidth"]);
    return (React.createElement(StyledInputContainer, { id: id, label: label, hint: hint, error: error, className: "saSelectWrapper " + (className || ''), icon: SAIcons.chevronDownBold, fullWidth: fullWidth },
        React.createElement("select", __assign({ defaultValue: defaultValue, ref: ref }, additionalProps), options.map(function (item) {
            return (React.createElement("option", { key: "" + item.label + item.value, label: item.label }, item.value));
        }))));
});
SASelect.defaultProps = {
    defaultValue: undefined,
};
var templateObject_1;
//# sourceMappingURL=select.component.js.map